export const MuiTablePaginationTheme = () => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {},
        },
    };
};
